import { Icon } from "@blueprintjs/core"
import { useEffect, useState } from "react"
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd"
import { VerticalType } from "src/libs/scalars/interface/IScalarForm"
import Scalar from "src/libs/scalars/scalars/Scalar"
import { LANDING_TYPE_CONTENT } from "../../data/interfaces"
import { ICompositeWidgetProps } from "../LandingCompositeWidget"
import LandingCompositeDefault from "./LandingCompositeDefault"
import { defaultValue } from "../../views/landing/primitive/HeaderPrimitive"

/* Protopia Ecosystem component */
export interface IHeaderElementOrderScalarProps extends ICompositeWidgetProps {
   
}



const HeaderElementOrderScalar = (props: IHeaderElementOrderScalarProps): JSX.Element => {
    return <>
        <Scalar  
            value={ props.value }
            editable={props.editable }
            subtitle={props.title}
            notClear
            rowClassName="width-auto"
            vertical={ VerticalType.VERTICAL }
            enabledForm={ <HeaderElementOrderEnabled {...props} /> }  
            desabledForm={ <HeaderElementOrderDisable {...props} /> }   
            subMenus={props.subMenus}
            onSubMenu={props.onSubmenu}
        />
    </>
}
export default HeaderElementOrderScalar

const HeaderElementOrderEnabled = (props: IHeaderElementOrderScalarProps): JSX.Element => {
    const [value, setValue] = useState<[ LANDING_TYPE_CONTENT.MENU, LANDING_TYPE_CONTENT.LOGO, LANDING_TYPE_CONTENT.CONTACTS ]>( 
        props.value || 
        props.default || 
        defaultValue
    )

    useEffect(() => {
        setValue( props.value )
    }, [ props.value ])

    const onChange = ( _value: [ LANDING_TYPE_CONTENT.MENU, LANDING_TYPE_CONTENT.LOGO, LANDING_TYPE_CONTENT.CONTACTS ], field: string ="", dop: any = {} ) => {
        setValue( _value ) 
        onFinalChange( _value )
    }  
    const onFinalChange = (newValue: [ LANDING_TYPE_CONTENT.MENU, LANDING_TYPE_CONTENT.LOGO, LANDING_TYPE_CONTENT.CONTACTS ]) => {
        if(props.onChange) {
            props.onChange( newValue, props.field, "" )
        }
    }
    const onElementChange = (newValue: any, type: [ LANDING_TYPE_CONTENT.MENU, LANDING_TYPE_CONTENT.LOGO, LANDING_TYPE_CONTENT.CONTACTS ]) => {
        alert( "HeaderElementOrderScalar." + type + " NO EDIT METHOD!")
    }

    // a little function to help us with reordering the result
    const reorder = (list: any[], startIndex: number, endIndex: number) => { 
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed); 
        return result;
    }; 

    const getItemStyle = (isDragging: boolean, draggableStyle: any) => ({ 
        userSelect: "none",
        padding: 0, 
        margin: `0 0 0 0`, 
        width: "100%",
        // change background colour if dragging
        background: isDragging ? "#a4bcf0" : "transparent", 
        color: isDragging ? "#d1ddf5" : undefined, 
        marginBottom: "4px",
        // styles we need to apply on draggable elements
        ...draggableStyle
    });

    const getListStyle = (isDraggingOver: boolean) => ({
        background: isDraggingOver ? "#8885b4cc" : "transparent",
        color: isDraggingOver ? "#5e7092" : undefined, 
        padding: 0, 
    })
    const onDragEnd = (result: any) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }  
        const _items: any[] = reorder(
            value || defaultValue,
            result.source.index,
            result.destination.index
        ); 
        onChange( _items as [LANDING_TYPE_CONTENT.MENU, LANDING_TYPE_CONTENT.LOGO, LANDING_TYPE_CONTENT.CONTACTS] )
    }
    
    return <div className="w-100 pl-1 pr-4 mr-2 d-flex flex-column flex-wrap"> 
        <DragDropContext onDragEnd={ onDragEnd }>
            <Droppable droppableId="droppable">
                {( provided, snapshot ) => (
                    <div
                        { ...provided.droppableProps }
                        ref={ provided.innerRef }
                        style={ getListStyle( snapshot.isDraggingOver ) }
                    >
                        { 
                            (value || defaultValue ).map((key: string, index: number) => { 
                                return <div key={key} className="d-flex"> 
                                    <Draggable draggableId={ key } index={ index }>
                                        {( provided, snapshot ) => ( 
                                            <div
                                                ref={ provided.innerRef }
                                                { ...provided.draggableProps }
                                                { ...provided.dragHandleProps }
                                                style={ getItemStyle(
                                                    snapshot.isDragging,
                                                    provided.draggableProps.style
                                                ) }
                                            > 
                                                {/* 
                                                <Button fill variant={ ButtonVariant.MINIMAL } size={ Size.LARGE } alignText={ "left" } className="p-0 btn-stretch " key={key}>
                                                    <div className="d-flex align-items-center">
                                                        
                                                        <div className="w-100 d-flex align-items-center justify-content-between py-2">
                                                            { key }
                                                        </div>
                                                    </div>
                                                </Button> 
                                                */}
                                                <div className="d-flex align-items-center">
                                                    <Icon icon="drag-handle-vertical" className="pl-2" />
                                                    <LandingCompositeDefault
                                                        dataSection=""
                                                        dataName={ key }
                                                        origin={ props.origin }
                                                        value={ props.origin[ key ] } 
                                                        onChange={ (value: any ) => onElementChange(value, key)}
                                                        type={ key }
                                                        key={ key }
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </Draggable>
                                </div>
                            })
                        }
                    </div>
                )}
            </Droppable >
        </DragDropContext>
    </div>
}

const HeaderElementOrderDisable = (props: IHeaderElementOrderScalarProps): JSX.Element => {
    return <></>
}